import {
  Box,
  Table,
  Button,
  Stack,
  Text,
  Group,
  Anchor,
  Image,
  ScrollArea
} from '@mantine/core'
import TitleDivider from '../divider'
import { useTranslations } from 'next-intl'
import { useRouter } from 'next/router'

const ContactsTable = ({ contacts, name, platformId }) => {
  const t = useTranslations('Platforms')
  const router = useRouter()

  const headerStyle = {
    backgroundColor: '#0E1922',
    color: '#FFFFFF',
    boxShadow: '0px -1px 0px 0px rgba(123,57,182,1) inset'
  }

  const validContacts = contacts
    .filter(
      (contact) => contact.company && contact.job && contact.name && contact.linkedin
    )
    .slice(0, 5)

  const handlePricingClick = () => {
    // Redirigir a la página de pricing con el global_id de la plataforma
    router.push(`/pricing?platform=${platformId}`)
  }

  return (
    <>
      <Box mt={20}>
        <TitleDivider titleText={t('contactsTitle') + name.toUpperCase()} />
      </Box>

      <Stack
        align="center"
        spacing={0}
        sx={(theme) => ({
          boxShadow: '0px -2px 0px 0px rgba(123,57,182,1) inset',
          backgroundColor: '#121E274D',
          padding: '20px',
          borderRadius: '10px',
          width: '100%',
          margin: '0 auto',
          [theme.fn.smallerThan('sm')]: {
            padding: '10px'
          }
        })}
      >
        <Text
          size="sm"
          color="dimmed"
          align="center"
          mb="xs"
          sx={(theme) => ({
            [theme.fn.smallerThan('sm')]: {
              fontSize: theme.fontSizes.xs
            }
          })}
        >
          {t('contactsDescription')}
        </Text>

        <Box sx={{ width: '100%' }}>
          <ScrollArea>
            <Table
              sx={(theme) => ({
                borderRadius: '10px',
                overflow: 'hidden',
                marginTop: '10px',
                minWidth: '600px',
                [theme.fn.smallerThan('sm')]: {
                  fontSize: theme.fontSizes.xs
                }
              })}
            >
              <thead>
                <tr>
                  <th style={headerStyle}>{t('company')}</th>
                  <th style={headerStyle}>{t('position')}</th>
                  <th style={headerStyle}>{t('name')}</th>
                  <th style={headerStyle}>{t('linkedin')}</th>
                </tr>
              </thead>
              <tbody>
                {validContacts.map((contact, index) => {
                  const blurLevel = Math.max(0, index - 1)
                  return (
                    <tr
                      key={index}
                      style={{
                        filter: `blur(${blurLevel}px)`,
                        borderStyle: 'hidden'
                      }}
                    >
                      <td style={{ color: '#4db5ff' }}>{contact.company}</td>
                      <td style={{ color: '#FFFFFF' }}>{contact.job}</td>
                      <td style={{ color: '#FFFFFF' }}>{contact.name}</td>
                      <td>
                        <Anchor
                          href={contact.linkedin}
                          target="_blank"
                          rel="noopener noreferrer"
                          sx={{
                            color: '#4db5ff',
                            textDecoration: 'none',
                            '&:hover': {
                              textDecoration: 'underline'
                            }
                          }}
                        >
                          <Group spacing={5}>
                            <Image
                              src="/linkedin.png"
                              width={20}
                              height={20}
                              alt="linkedin"
                            />
                            <Text size="sm">LinkedIn</Text>
                          </Group>
                        </Anchor>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </Table>
          </ScrollArea>
        </Box>

        <Button
          radius="sm"
          size="xs"
          onClick={handlePricingClick}
          sx={(theme) => ({
            marginTop: '20px',
            backgroundColor: '#7B39B6',
            color: '#FFFFFF',
            [theme.fn.smallerThan('sm')]: {
              width: '100%'
            }
          })}
        >
          {t('getFullContactsList') + name.toUpperCase()}
        </Button>
      </Stack>
    </>
  )
}

export default ContactsTable
